import { AnalyticsService } from "./AnalyticsService";

const navbarAnalytics = new AnalyticsService("Navbar");

const analyticsPathByMenuKey: Record<string, string[]> = {
  activitiesPlan: ["Plan", "Activities"],
  companiesListRecords: ["Records", "Company List"],
  companiesMap: ["Map", "Companies Map"],
  companyGroupsPlan: ["Plan", "Groups", "Company Groups"],
  dealGroupsPlan: ["Plan", "Groups", "Deal Groups"],
  dealsMap: ["Map", "Deals Map"],
  funnelsDealsRecords: ["Records", "Deals"],
  importsManage: ["Manage", "Imports"],
  integrationsManage: ["Manage", "Integrations"],
  manageUsersManage: ["Manage", "Manage Users"],
  peopleGroupsPlan: ["Plan", "Groups", "People Groups"],
  peopleListRecords: ["Records", "People List"],
  peopleMap: ["Map", "People Map"],
  reports: ["Reports"],
  resources: ["Resources"],
  routes: ["Routes"],
  territoriesMap: ["Map", "Territories Map"],
};

export const navbarMenuClick = (key: string) => {
  if (analyticsPathByMenuKey[key]) {
    navbarAnalytics.clicked(["Menu item"], { item: analyticsPathByMenuKey[key] });
  }
};

const analyticsPathByRightMenuKey: Record<string, string[]> = {
  addActivity: ["Plus", "Add Activity"],
  addCompany: ["Plus", "Add Company"],
  addDeal: ["Plus", "Add Deal"],
  addPerson: ["Plus", "Add Person"],
  import: ["Plus", "Import"],
  integrations: ["Plus", "Integrations"],
};

export const navbarRightMenuClick = (key: string) => {
  if (analyticsPathByRightMenuKey[key]) {
    navbarAnalytics.clicked(["Menu item"], { item: analyticsPathByRightMenuKey[key] });
  }
};

const analyticsPathByUserMenuKey: Record<string, string[]> = {
  changePassword: ["Change Password"],
  manageSubscription: ["Manage Subscription"],
  support: ["Support"],
};

export const navbarUserMenuClick = (key: string) => {
  if (analyticsPathByUserMenuKey[key]) {
    navbarAnalytics.clicked(["Menu item"], { item: analyticsPathByUserMenuKey[key] });
  }
};

export default navbarAnalytics;
